export default function (params) {
  let el = document.getElementById(params.elId);
  if (params.remove) {
    el.classList.remove(params.className);
  } else if (el !== null && el.classList !== null) {
    el.classList.toggle(params.className);
  }
}



// WEBPACK FOOTER //
// ./src/theme/dom/toggleClass.js